import { Button } from '@creditornot/cb-button';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { unsubscribeReport } from 'apis/merchant-gateway/insights';
import { Typography } from 'common/typography';
import Loading from 'core/Loading';

import {
  ScreenCenteredImage,
  ScreenContainer,
  ScreenInformation,
  ScreenHeader,
  ScreenActionsContainer,
} from './screens.styled';
import HorribleImage from '../../../images/horrible.png';
import ThumbsUpImage from '../../../images/thumbsup.png';

export const Unsubscribed = ({ onBack }: { onBack: () => void }) => {
  const { reportId } = useParams<{ reportId: string }>();
  const { locale } = useIntl();
  const { isLoading, isError } = useQuery(
    ['report', 'unsubscribe', reportId],
    () => unsubscribeReport({ reportId, locale }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  );

  return (
    <ScreenContainer>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {isError ? (
            <>
              <ScreenCenteredImage src={HorribleImage} />
              <ScreenInformation>
                <ScreenHeader>
                  <FormattedMessage id="insights.reports.result.error.title" />
                </ScreenHeader>
                <Typography.Body3>
                  <FormattedMessage id="insights.reports.result.error.description" />
                </Typography.Body3>
              </ScreenInformation>
            </>
          ) : (
            <>
              <ScreenCenteredImage src={ThumbsUpImage} />
              <ScreenInformation>
                <ScreenHeader>
                  <FormattedMessage id="insights.reports.unsubscribed.title" />
                </ScreenHeader>
                <Typography.Body3>
                  <FormattedMessage id="insights.reports.unsubscribed.description" />
                </Typography.Body3>
                <Typography.Body3>
                  <FormattedMessage id="insights.reports.unsubscribed.wish-you-the-best" />
                </Typography.Body3>
              </ScreenInformation>
            </>
          )}
          <ScreenActionsContainer>
            <Button variant="blue" size="small" onClick={onBack}>
              <FormattedMessage id="insights.reports.result.back-to-insights" />
            </Button>
          </ScreenActionsContainer>
        </>
      )}
    </ScreenContainer>
  );
};
